angular.module('FlexyBeautyApp.services')
    .factory('KycStatusConstants', ['gettextCatalog', function (gettextCatalog) {
        let kycStatus = {
            NOT_CERTIFIED:
                {
                    key: 'notCertified',
                    label: gettextCatalog.getString("Non certifié")
                },
            VALIDATION_ASKED:
                {
                    key: 'validating',
                    label: gettextCatalog.getString("En cours de certification")
                },
            INCOMPLETE:
                {
                    key: 'incomplete',
                    label: gettextCatalog.getString("Dossier à compléter")
                },
            CERTIFIED:
                {
                    key: 'certified',
                    label: gettextCatalog.getString("Certifié")
                }
        };

        kycStatus.getStatusByKey = function(key){
          for(let status in kycStatus) {
              if(kycStatus[status].key === key){
                  return kycStatus[status];
              }
          }
        };

        return kycStatus;

    }]);



// WEBPACK FOOTER //
// ./js/services/views/KycStatusConstants.js